"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var userManager_1 = require("../../userManager/userManager");
var authProvider_1 = require("../../authProvider");
/**
 * Processes the response from the authorization provider.
 * @param onCallback
 * Function to execute after coming back from provider. Ex: Navigate to a private component.
 * @param LoadingComponent
 * What loading component to show while callback is taking place.
 */
exports.CallbackComponent = function (_a) {
    var onCallback = _a.onCallback, loadingComponent = _a.loadingComponent;
    var setUser = authProvider_1.useSSOClient().setUser;
    var Loader = loadingComponent;
    var userManager = userManager_1.UserManager.getInstance();
    react_1.useEffect(function () {
        userManager.signinRedirectCallback().then(function (userFromCallback) {
            localStorage.setItem("access_token", userFromCallback.access_token);
            onCallback(userFromCallback);
            setUser(userFromCallback);
        }).catch(function () {
            onCallback();
        });
    }, []);
    return react_1.default.createElement(Loader, null);
};
//# sourceMappingURL=CallbackComponent.js.map